// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1506":"fdd4bb2a","2048":"fdd4bb2a","2880":"fdd4bb2a","3144":"fdd4bb2a","5209":"aba3188c","6078":"fdd4bb2a","6444":"2723e70b","7319":"fdd4bb2a","7381":"fdd4bb2a","8904":"fdd4bb2a"}[chunkId] + ".chunk.css";
};